// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","main":"App_main__nhgh3","chatContainers":"App_chatContainers__VnG2x","inputContainer":"App_inputContainer__EQ9Iv"};